/**
 * keybindingManager — Centralized combat hotkey dispatch (Tab, QWER, DF, A).
 * Shop (P) lives on InputController only — dual listeners would open+close in one keydown.
 * Action keys resolve via DEFAULT_KEY_REMAPS / setRemaps (SPY-113).
 */

import {
  DEFAULT_KEY_REMAPS,
  keyMatchesAction
} from '../../domain/input/defaultKeyRemaps.js';

const COMBAT_DOWN = Object.freeze([
  ['attackMove', 'onToggleRange'],
  ['abilityQ', 'onActivateQ'],
  ['abilityW', 'onCastW'],
  ['abilityE', 'onCastE'],
  ['abilityR', 'onCastR'],
  ['summonerD', 'onCastD'],
  ['summonerF', 'onCastF']
]);

function copyRemaps(source) {
  return { ...(source || DEFAULT_KEY_REMAPS) };
}

export class KeybindingManager {
  constructor(handlers = {}, { remaps } = {}) {
    this.handlers = handlers;
    this.remaps = copyRemaps(remaps);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  setRemaps(remaps) {
    this.remaps = copyRemaps(remaps);
  }

  init() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  }

  destroy() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  }

  onKeyDown(e) {
    if (keyMatchesAction(e.key, 'scoreboard', this.remaps)) {
      e.preventDefault();
      if (typeof this.handlers.onOpenScoreboard === 'function') {
        this.handlers.onOpenScoreboard();
      }
      return;
    }
    for (const [action, handlerName] of COMBAT_DOWN) {
      const fn = this.handlers[handlerName];
      if (keyMatchesAction(e.key, action, this.remaps) && typeof fn === 'function') {
        fn();
      }
    }
  }

  onKeyUp(e) {
    if (keyMatchesAction(e.key, 'scoreboard', this.remaps)) {
      e.preventDefault();
      if (typeof this.handlers.onCloseScoreboard === 'function') {
        this.handlers.onCloseScoreboard();
      }
    }
  }
}
